import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import { /*object_type, api_crud_base,*/ api_crud_route, data_interface, endpoints } from './Config';
import AssecCKEditor from "../../../ASSEC_CKEditor/ASSEC_CKEditor";

import { getTokenInfo } from '../../../../UseToken';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

import {

	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	content_language,

} from '../../../../Utils';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);

	const [show_delete_button, set_show_delete_button] = useState(false);

	/*const editor = useRef(null)
	const config = {
        readonly: false // all options from https://xdsoft.net/jodit/doc/
    }*/

	//const [disabled, set_disabled] = useState(true)

	const [is_edit, set_is_edit] = useState(false)

	const fetch_id_info = async (id_serch) => {

		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = res.data[0]);

			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	useEffect(() => {
		clean_data();


		console.log(props.location.state.item)

        set_lang(localStorage.getItem('lang'))

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				//set_disabled(true)

				set_is_edit(true)

				set_show_delete_button(true)

				fetch_id_info(props.location.state.item['id']).then(() => {
					setLoading(false)
				})
				return
			}
			else {
				set_dados(dados.current.info.feature = props.location.state.item['info']['feature'])
				set_dados(dados.current.info.order = parseInt(props.location.state.item['order']) + 1)
				setLoading(false)
			}

		} catch {
			clean_data()

			setLoading(false);

			setRedirect(false);
			return
		}

		return () => {
			clean_data()
		}

	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {

			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					reqPUT(api_crud_route, dados.current)
						.then(() => { 
							//props.history.push(endpoints.list) 
							props.history.push({
								pathname: endpoints.list,
								state: { item: {id: props.location.state.item['info']['feature']} }
							})
						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})

		} else {

			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {

					reqPOST(api_crud_route, dados.current)
						.then(() => { 
							//props.history.push(endpoints.list) 
							props.history.push({
								pathname: endpoints.list,
								state: { item: {id: props.location.state.item['info']['feature']} }
							})
						})
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})

		}
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route, { id: dados.current.id })
					.then(() => {
						//props.history.push(endpoints.list) 
						props.history.push({
							pathname: endpoints.list,
							state: { item: {id: props.location.state.item['info']['feature']} }
						})
					})
					.catch(error => console.log(error))
			}
		})
		.catch((erro) => {
			console.log(erro)
		})
		
	};

	const handle_change_info = (e) => {
		const { name, value, dataset } = e.target;
		const { lang, langid } = dataset

		if(langid === '1') {
			set_dados(dados.current.info[name] = value)
		}
		else {
			if(dados.current.info['language'] === undefined)
				dados.current.info['language'] = []

			if(dados.current.info.language.length  === 0) {
				//dados.current.info.language[lang] = {id: langid, code: lang, title: '', abstract: '', text: ''}
				dados.current.info.language[langid] = {id: langid, code: lang, name: '', description: '', media: {image: [], doc: []}}
			}

			set_dados(dados.current.info['language'][langid][name] = value)
		}

		if(name === 'bgColor')
			set_dados(dados.current.info.borderColor = value)



		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	/*const handle_change_info_description = (e) => {
		set_dados(dados.current.info['description'] = e)
	}*/

	const handle_change_info_ckeditor = (value, order, langid, lang, name) => {

		console.log('handle_change_info_ckeditor', value);

		if (langid === '1') {
			set_dados(dados.current.info[name] = value)
		}
		else {
			if (dados.current.info['language'] === undefined)
				dados.current.info['language'] = []

			if (dados.current.info.language.length === 0) {
				dados.current.info.language[langid] = { id: langid, code: lang, name: '', description: '' }
			}

			set_dados(dados.current.info['language'][langid][name] = value)
		}

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handleSingleCheck = e => {
		const { name } = e.target;

		set_dados(dados.current.info[name] = !dados.current.info['status'])
	}

	const get_value_info_lang = (langid, name) => {
		if(dados.current.info['language'] !== undefined && dados.current.info['language'] !== null) {
			if(dados.current.info['language'][langid] !== undefined && dados.current.info['language'][langid] !== null) {
				return dados.current.info['language'][langid][name];
			}
			else {
				return '';
			}
		}
		else {
			return '';
		}
	}


	return isloading ?
		
		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:

			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].component}</h2>
					<p>{language[lang].component} / {dados.current.id !== '' ? language[lang].component_edit : language[lang].component_new}</p>
				</div>
		
				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
		
							<div className="mb-5 mb-xl-10">
								<div className='card'>

									<div className="card-header border-0 d-flex justify-content-sm-between">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{dados.current.info.name.length > 0 ? dados.current.info.name : language[lang].component_new}</h3>
										</div>
										<div className="card-toolbar">
											<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
												{
												content_language.length > 1 ?
													content_language.map((el_lang, k_lang) => {
														return (
															<li key={k_lang} className="nav-item">
																<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#kt_tab_pane_content_language_" + k_lang}>{el_lang.code}</a>
															</li>
														)
													})
												:
													''
												}
											</ul>
										</div>
									</div>
									<div id="div-content">

										<form id="form" onSubmit={handleSubmit}>
											<div className="card-body border-top p-4">
												<div className="tab-content" id={"tab_entidade_lang"} >
													{
													content_language.length > 1 ?
														content_language.map((el_lang, k_lang) => {
															return (
																<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"kt_tab_pane_content_language_" + k_lang} role="tabpanel">
																	<div className="row mb-3">
																		<div className="col-md-8">
																			<label className={el_lang.id === '1' ? "fs-5 required fw-bold mb-2" : "fs-5 fw-bold mb-2"}>{language[lang].field_name} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																			<input type="text" name="name" data-langid={el_lang.id} data-lang={el_lang.code} value={el_lang.id === '1' ? dados.current.info.name : get_value_info_lang(el_lang.id, 'name')} className="form-control" placeholder={language[lang].field_name_placeholder} onChange={handle_change_info} required={el_lang.id === '1' ? 'required' : ''} />
																		</div>

																		<div className="col-md-4">
																			<label className="fs-5 fw-bold mb-2">{language[lang].field_abreviation} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																			<input type="text" name="abreviation" value={dados.current.info.abreviation} className="form-control" placeholder={language[lang].field_abreviation_placeholder} onChange={handle_change_info} />
																		</div>
																	</div>

																	<div className="row mb-3">
																		<div className="col-md-4">
																			<label className="fs-5 fw-bold mb-2">{language[lang].color}</label>
																			<div className="input-group">
																				<div className="me-5">
																					<input type="color" name="bgColor" value={dados.current.info.bgColor !== '' ? dados.current.info.bgColor : '#000000'} className="form-control form-control-color" placeholder={language[lang].color_placeholder} onChange={handle_change_info} />
																				</div>
																				<span className="form-control">{dados.current.info.bgColor}</span>
																			</div>
																		</div>

																		<div className="col-md-6">
																		</div>

																		<div className="col-md-2">
																			<label className="fs-5 fw-bold mb-2">{language[lang].field_status}</label>
																			<div className="input-group">
																				<div className="form-check form-check-solid form-switch">
																					<input
																						id={'item-switch'}
																						name={"status"}
																						className="form-check-input w-45px h-30px"
																						type="checkbox"
																						value={dados.current.info.status}
																						onChange={handleSingleCheck}
																						defaultChecked={dados.current.info.status}
																					/>
																					<label className="form-check-label" htmlFor={'item-switch'}></label>
																				</div>
																			</div>
																		</div>
																	</div>

																	<div className="row mb-3">
																		<div className="col-md-12">
																			<label className="fs-5 fw-bold mb-2">{language[lang].field_description} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>

																			<AssecCKEditor
																				name={"description"}
																				content={el_lang.id === '1' ? dados.current.info.description : get_value_info_lang('0', el_lang.id, 'description')}
																				func={(e) => handle_change_info_ckeditor(e, '0', el_lang.id, el_lang.code, 'description')}
																			/>

																			<textarea className="form-control d-none" type="text" name="description" value={dados.current.info.description} placeholder={language[lang].field_description_placeholder} onChange={handle_change_info} />
																		</div>
																	</div>
																</div>
															)
														})
													:
														<div>
															<div className="row mb-3">
																<div className="col-md-8">
																	<label className="fs-5 required fw-bold mb-2">{language[lang].field_name}</label>
																	<input type="text" name="name" value={dados.current.info.name} className="form-control" placeholder={language[lang].field_name_placeholder} onChange={handle_change_info} required />
																</div>

																<div className="col-md-4">
																	<label className="fs-5 fw-bold mb-2">{language[lang].field_abreviation}</label>
																	<input type="text" name="abreviation" value={dados.current.info.abreviation} className="form-control" placeholder={language[lang].field_abreviation_placeholder} onChange={handle_change_info} />
																</div>
															</div>

															<div className="row mb-3">
																<div className="col-md-4">
																	<label className="fs-5 fw-bold mb-2">{language[lang].color}</label>
																	<div className="input-group">
																		<div className="me-5">
																			<input type="color" name="bgColor" value={dados.current.info.bgColor} className="form-control form-control-color" placeholder={language[lang].color_placeholder} onChange={handle_change_info} />
																		</div>
																		<span className="form-control">{dados.current.info.bgColor}</span>
																	</div>
																</div>

																<div className="col-md-6">
																</div>

																<div className="col-md-2">
																	<label className="fs-5 fw-bold mb-2">{language[lang].field_status}</label>
																	<div className="input-group">
																		<div className="form-check form-check-solid form-switch">
																			<input
																				id={'item-switch'}
																				name={"status"}
																				className="form-check-input w-45px h-30px"
																				type="checkbox"
																				value={dados.current.info.status}
																				onChange={handleSingleCheck}
																				defaultChecked={dados.current.info.status}
																			/>
																			<label className="form-check-label" htmlFor={'item-switch'}></label>
																		</div>
																	</div>
																</div>
															</div>

															<div className="row mb-3">
																<div className="col-md-12">
																	<label className="fs-5 fw-bold mb-2">{language[lang].field_description}</label>

																	<AssecCKEditor
																		name={"description"}
																		content={dados.current.info.description}
																		func={(e) => handle_change_info_ckeditor(e, '0', '1', 'pt', 'description')}
																	/>

																	<textarea className="form-control d-none" type="text" name="description" value={dados.current.info.description} placeholder={language[lang].field_description_placeholder} onChange={handle_change_info} />
																</div>
															</div>
														</div>
													}
												</div>
											</div>

										</form>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list, state: { item: { id: props.location.state.item.info.feature }}}} >
										<img alt='' src={'./img/cancelar.svg'} />
										<span>{language[lang].cancel}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<img alt='' src={'./img/eliminar_b.svg'} />
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<img alt='' src={'./img/save.svg'} />
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main>
}
